module.exports = __webpack_public_path__ + "static/media/db_data_error.c64f716d.svg";